export const ISO2_TO_ISO3: Record<string, string> = {
  AE: 'ARE',
  AO: 'AGO',
  AR: 'ARG',
  AT: 'AUT',
  AU: 'AUS',
  BD: 'BGD',
  BE: 'BEL',
  BH: 'BHR',
  BO: 'BOL',
  BR: 'BRA',
  BW: 'BWA',
  CA: 'CAN',
  CH: 'CHE',
  CL: 'CHL',
  CN: 'CHN',
  CO: 'COL',
  CR: 'CRI',
  CZ: 'CZE',
  DE: 'DEU',
  DK: 'DNK',
  DO: 'DOM',
  DZ: 'DZA',
  EE: 'EST',
  EG: 'EGY',
  ES: 'ESP',
  ET: 'ETH',
  FI: 'FIN',
  FJ: 'FJI',
  FR: 'FRA',
  GB: 'GBR',
  GH: 'GHA',
  GR: 'GRC',
  GT: 'GTM',
  HK: 'HKG',
  HR: 'HRV',
  HU: 'HUN',
  ID: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IN: 'IND',
  IQ: 'IRQ',
  IR: 'IRN',
  IS: 'ISL',
  IT: 'ITA',
  JM: 'JAM',
  JO: 'JOR',
  JP: 'JPN',
  KE: 'KEN',
  KR: 'KOR',
  KW: 'KWT',
  LB: 'LBN',
  LK: 'LKA',
  LT: 'LTU',
  LU: 'LUX',
  LY: 'LBY',
  MA: 'MAR',
  MG: 'MDG',
  MX: 'MEX',
  MY: 'MYS',
  MZ: 'MOZ',
  NG: 'NGA',
  NL: 'NLD',
  NO: 'NOR',
  NP: 'NPL',
  NZ: 'NZL',
  OM: 'OMN',
  PA: 'PAN',
  PE: 'PER',
  PG: 'PNG',
  PH: 'PHL',
  PK: 'PAK',
  PL: 'POL',
  PT: 'PRT',
  PY: 'PRY',
  QA: 'QAT',
  RO: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  SA: 'SAU',
  SE: 'SWE',
  SG: 'SGP',
  SI: 'SVN',
  SK: 'SVK',
  SN: 'SEN',
  SV: 'SLV',
  TH: 'THA',
  TN: 'TUN',
  TR: 'TUR',
  TT: 'TTO',
  TW: 'TWN',
  UA: 'UKR',
  UG: 'UGA',
  UM: 'UMI',
  US: 'USA',
  UY: 'URY',
  VE: 'VEN',
  VN: 'VNM',
  ZA: 'ZAF',
  ZW: 'ZWE'
};
